import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=5e5ec5d4"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=5e5ec5d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports